import { render, staticRenderFns } from "./ListHeader.vue?vue&type=template&id=17cd6136&"
import script from "./ListHeader.vue?vue&type=script&lang=js&"
export * from "./ListHeader.vue?vue&type=script&lang=js&"
import style0 from "./ListHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListHeaderTitle: require('/app/components/list/ListHeaderTitle.vue').default,ListLinkMore: require('/app/components/list/ListLinkMore.vue').default})
